import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { HomeComponent } from './home/home.component';
import { FormsModule } from '@angular/forms';
import { SignupMiddlewareComponent } from './signup-middleware/signup-middleware.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthConnectComponent } from './auth-connect/auth-connect.component';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { SigninComponent } from './signin/signin.component';
import { EmailSignupComponent } from './signup-page/email-signup/email-signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CommonLayoutModule, DeviceTypeDirective } from '@laasy/common-layout';
import { SsoSignupComponent } from './signup-page/ssosignup/ssosignup.component';
import { PersonalInfoComponent } from './signup-page/personal-info/personal-info.component';
import { ContactNoComponent } from './signup-page/contact-no/contact-no.component';
import { VerifyOtpComponent } from './signup-page/verify-otp/verify-otp.component';
import { MarketingInfoComponent } from './signup-page/marketing-info/marketing-info.component';
import { FormNavigationButtonsComponent } from './signup-page/components/form-navigation-buttons/form-navigation-buttons.component';
import { ProgressBarComponent } from './signup-page/components/progress-bar/progress-bar.component';
import { AuthConnectHeaderComponent } from './signup-page/components/auth-connect-header/auth-connect-header.component';
import { UpdatePasswordComponent } from './signup-page/components/update-password/update-password.component';
import { SubtenantSelectionComponent } from './signup-page/subtenant-selection/subtenant-selection.component';
import { IdpBasedSignupComponent } from './signup-page/idp-based-signup/idp-based-signup.component';
import { CommonWelcomeComponent } from './signup-page/components/common-welcome/common-welcome.component';
import { InputComponent } from 'src/app/shared/components/validation/validations.component';
import { MinuteSecondsPipe } from 'src/app/shared/pipes/minute-seconds.pipe';
import { ToastComponent } from 'src/app/shared/components/toast/toast.component';
import { TenantDomainNamePipe } from "../../shared/pipes/tenant-domain-name.pipe";
import { AuthCodeComponent } from './signup-page/auth-code/auth-code.component';
import { CircularSelectionComponent } from 'src/app/shared/components/circular-selection/circular-selection.component';
import { SurveyComponent } from './signup-page/survey/survey.component';
import { LaasyModalComponent } from 'src/app/shared/components/laasy-modal/laasy-modal.component';

@NgModule({
  declarations: [
    HomeComponent,
    SignupMiddlewareComponent,
    AuthConnectComponent,
    SigninComponent,
    EmailSignupComponent,
    ForgotPasswordComponent,
    SsoSignupComponent,
    PersonalInfoComponent,
    ContactNoComponent,
    VerifyOtpComponent,
    MarketingInfoComponent,
    FormNavigationButtonsComponent,
    ProgressBarComponent,
    AuthConnectHeaderComponent,
    UpdatePasswordComponent,
    SubtenantSelectionComponent,
    IdpBasedSignupComponent,
    CommonWelcomeComponent,
    AuthCodeComponent,
    SurveyComponent
  ],
  imports: [
    InputComponent,
    MinuteSecondsPipe,
    ToastComponent,
    CommonLayoutModule,
    NgxOtpInputModule,
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    ProgressSpinnerModule,
    DeviceTypeDirective,
    TenantDomainNamePipe,
    CircularSelectionComponent,
    LaasyModalComponent
],
exports: [SurveyComponent,FormNavigationButtonsComponent,ProgressBarComponent,MarketingInfoComponent]
})
export class AuthModule { }
